import { render, staticRenderFns } from "./GatewayManagement.vue?vue&type=template&id=146a0837&"
import script from "./GatewayManagement.vue?vue&type=script&lang=js&"
export * from "./GatewayManagement.vue?vue&type=script&lang=js&"
import style0 from "./GatewayManagement.vue?vue&type=style&index=0&id=146a0837&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports